module.exports = __webpack_public_path__ + "img/laba.e8463526.png";